export interface SyncDateWindowConstructor {
  startDate: Nullable<Date>
  endDate: Nullable<Date> // null = "Now" (no fixed end date)
}

export class SyncDateWindow {
  readonly startDate: Nullable<Date>
  readonly endDate: Nullable<Date>

  constructor(data: SyncDateWindowConstructor) {
    this.startDate = data.startDate
    this.endDate = data.endDate
  }

  // "END DATE" label on export pages renders only when set (BHV-030);
  // empty End Date fields display the placeholder "Now" (BHV-009).
  get hasEndDate(): boolean {
    return this.endDate !== null
  }
}
